import jsPDF from 'jspdf';

// ── paleta ─────────────────────────────────────────────────────────────────────
export const NAVY:  [number,number,number] = [27,  58,  92];
export const GRAY:  [number,number,number] = [107,114,128];
export const LGRAY: [number,number,number] = [209,213,219];
export const BLACK: [number,number,number] = [17,  24,  39];
export const WHITE: [number,number,number] = [255,255,255];
export const LBLUE: [number,number,number] = [235,244,250];

// ── helpers gerais ──────────────────────────────────────────────────────────────
export const v   = (s?: string|null) => (s ?? '').trim();
export const fmt = (iso?: string|null) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,'0')}/${String(d.getMonth()+1).padStart(2,'0')}/${d.getFullYear()}`;
};
export const hhmm = (iso?: string|null) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
};
export const f = (doc: jsPDF, m: 'fill'|'stroke'|'text', c: [number,number,number]) => {
  if (m==='fill')   doc.setFillColor(c[0],c[1],c[2]);
  if (m==='stroke') doc.setDrawColor(c[0],c[1],c[2]);
  if (m==='text')   doc.setTextColor(c[0],c[1],c[2]);
};

// ── primitivos de desenho ───────────────────────────────────────────────────────

export function secBox(doc: jsPDF, x: number, y: number, w: number, h: number) {
  f(doc,'stroke',LGRAY); f(doc,'fill',WHITE);
  doc.setLineWidth(0.3);
  doc.roundedRect(x, y, w, h, 2, 2, 'S');
}

export function secBar(doc: jsPDF, x: number, y: number, w: number, label: string) {
  f(doc,'fill',NAVY); f(doc,'stroke',NAVY);
  doc.roundedRect(x, y, w, 6.5, 1, 1, 'F');
  f(doc,'text',WHITE);
  doc.setFont('helvetica','bold'); doc.setFontSize(7.5);
  doc.text(label, x+3.5, y+4.5);
}

export function colHead(doc: jsPDF, x: number, y: number, w: number, label: string) {
  f(doc,'fill',LBLUE); f(doc,'stroke',LGRAY);
  doc.setLineWidth(0.2);
  doc.rect(x, y, w, 5, 'FD');
  f(doc,'text',NAVY);
  doc.setFont('helvetica','bold'); doc.setFontSize(6);
  doc.text(label, x+w/2, y+3.6, { align:'center' });
}

export function ul(doc: jsPDF, x: number, y: number, w: number) {
  f(doc,'stroke',LGRAY); doc.setLineWidth(0.2);
  doc.line(x, y, x+w, y);
}

/** Campo inline "Label: valor" com sublinhado */
export function field(doc: jsPDF, label: string, value: string, x: number, y: number, w: number) {
  f(doc,'text',GRAY); doc.setFont('helvetica','normal'); doc.setFontSize(6.5);
  doc.text(label, x, y);
  const lw = doc.getTextWidth(label)+1.5;
  const vw = w - lw;
  ul(doc, x+lw, y+1, vw);
  if (value) {
    f(doc,'text',BLACK); doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
    const lines = doc.splitTextToSize(value, vw-0.5);
    doc.text(lines[0], x+lw, y);
  } else {
    f(doc,'text',LGRAY); doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
    doc.text('—', x+lw, y);
  }
}

/** Texto multi-linha com sublinhados */
export function multiLine(
  doc: jsPDF,
  label: string,
  value: string,
  x: number,
  y: number,
  w: number,
  nLines: number,
  lineH = 5.5,
) {
  f(doc,'text',GRAY); doc.setFont('helvetica','normal'); doc.setFontSize(6.5);
  doc.text(label, x, y);
  const lw  = doc.getTextWidth(label)+1.5;
  const all = doc.splitTextToSize(value, w - lw - 0.5);

  for (let i = 0; i < nLines; i++) {
    const lx  = i === 0 ? x+lw : x;
    const lnW = i === 0 ? w-lw  : w;
    const ly  = y + i*lineH;
    ul(doc, lx, ly+1, lnW);
    if (all[i]) {
      f(doc,'text',BLACK); doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
      doc.text(all[i], lx, ly);
    }
  }
}

/** Célula de exame "OD: ___valor___" com sublinhado */
export function examCell(doc: jsPDF, label: string, value: string, x: number, y: number, w: number) {
  f(doc,'text',GRAY); doc.setFont('helvetica','normal'); doc.setFontSize(6.5);
  doc.text(label, x, y);
  const lw = doc.getTextWidth(label)+1;
  ul(doc, x+lw, y+0.8, w-lw);
  if (value) {
    f(doc,'text',BLACK); doc.setFont('helvetica','normal'); doc.setFontSize(7);
    doc.text(value, x+lw+0.5, y);
  }
}
